import {RadioBoxOptions} from '@/types';

const getAccountDisplayTypeOptions = (): RadioBoxOptions => ({
  name: 'accountDisplayTypeOptions',
  data: [
    {
      id: 'accountDisplayTypesRandom',
      value: 'RANDOM',
      dispaly: 'BANNER_LIST_RANDOM',
    },
    {
      id: 'accountDisplayTypesSequential',
      value: 'SEQUENTIAL',
      dispaly: 'BANNER_LIST_SEQUENTIAL',
    },
  ],
});

type SectionType = 'platform'|'grade'|'group'

const getSameAsSectionOptions = (type: SectionType): RadioBoxOptions => ({
  name: `customOptionUseOptions_${type}`,
  data: [
    {
      id: `customOptionUseY_${type}`,
      value: 'NONE',
      dispaly: 'BANNER_LIST_SAME_AS_SECTION',
    },
    {
      id: `customOptionUseN_${type}`,
      value: 'ANY',
      dispaly: 'BANNER_LIST_CUSTOM_OPTION',
    },
  ],
})

// 'platform'|'grade'|'group'

const bannerDisplayOptions = () => ({
  accountDisplayType: getAccountDisplayTypeOptions(),
  sameAsSectionOptions: {
    platform: getSameAsSectionOptions('platform'),
    grade: getSameAsSectionOptions('grade'),
    group: getSameAsSectionOptions('group'),
  },
})

export default bannerDisplayOptions;